import { Login, LoginForm } from "react-admin";
import { Box, Typography } from "@mui/material";

export default function CustomLoginPage() {
  return (
    <Login
      avatarIcon={
        <Box
          component="img"
          src="/logo.png"
          alt="Dinamo Ostia"
          sx={{ width: 56, height: 56, borderRadius: "50%" }}
        />
      }
    >
      <Box sx={{ textAlign: "center", pt: 1, pb: 2 }}>
        <Typography variant="h6" fontWeight={900}>
          Dinamo Ostia
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Pannello di amministrazione
        </Typography>
      </Box>
      <LoginForm />
    </Login>
  );
}
